import { green, red } from '@mui/material/colors';
import { Text } from '@/theme/index';
import { convertToPercentage, commaFormatCurrency } from '@/utils/index';

interface VSIHistoryBasedTextProps {
  historyBasedValue: number;
  averageMarketValue: number;
}

export function VSIHistoryBasedText({
  historyBasedValue,
  averageMarketValue,
}: VSIHistoryBasedTextProps) {
  const priceDifference = historyBasedValue - averageMarketValue;
  const formattedPriceDifference = commaFormatCurrency(priceDifference);
  const percentDifference = convertToPercentage(
    historyBasedValue / averageMarketValue - 1
  );
  const lessThanAveragePrice = priceDifference < 0;
  const greaterThanAveragePrice = priceDifference > 0;
  const priceDifferential = () => {
    return `${formattedPriceDifference} (${percentDifference})`;
  };

  const comparativeText = () => {
    switch (true) {
      case lessThanAveragePrice: {
        return ` lower than the average market value of ${commaFormatCurrency(
          averageMarketValue
        )}`;
      }
      case greaterThanAveragePrice: {
        return ` greater than the average market value of ${commaFormatCurrency(
          averageMarketValue
        )}`;
      }
      default: {
        return 'Equal to the average market value';
      }
    }
  };

  const priceDifferentialColor = () => {
    switch (true) {
      case lessThanAveragePrice: {
        return red[400];
      }
      case greaterThanAveragePrice: {
        return green[500];
      }
      default: {
        return 'grey';
      }
    }
  };

  return (
    <Text paddingBottom="0.375rem">
      <Text
        component="span"
        sx={{ fontWeight: '700', color: priceDifferentialColor() }}
      >
        {priceDifferential()}
      </Text>
      &nbsp;
      {comparativeText()}
    </Text>
  );
}
